import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BulkTalentModalFooter.scss';

import SelectOption from '../General/SelectOption';

const BulkTalentModalFooter = props => {
  const { curMessage, curRate, validSelectedTalent, outreachOptions, outreachType } = props;
  const selectOutreachType = data => {
    data.onSelectOverride ? data.onSelectOverride() : props.setOutreachTypeEnum(data.value.type);
  };
  const noneRemaining = outreachType.numRemaining === 0;
  const hasMessage = curMessage.length >= 2;
  const hasValidTalent = validSelectedTalent.length > 0;
  const hasRate = curRate.length > 0;
  const needsRateAndDoesntHave = outreachType.showRate && !hasRate;
  const isDisabled = hasRate ? !hasValidTalent || needsRateAndDoesntHave : !hasMessage || !hasValidTalent || noneRemaining || outreachType.isDisabled;

  const note = outreachType.disabledMessage || outreachType.warningMessage;
  return (
    <div className='bulk-talent-modal-footer'>
      <div className='actions'>
        <Select
          unstyled
          placeholder='Outreach Type'
          classNamePrefix='outreach-select'
          menuPlacement='top'
          onChange={selectOutreachType}
          className='outreach-select'
          isOptionDisabled={option => !!option.value.disabledMessage}
          options={outreachOptions}
          value={outreachOptions.find(o => o.value.type === outreachType.type)}
          components={{ Option: SelectOption }}
        />
        <div onClick={() => outreachType.clickSend(validSelectedTalent)} className={cn('send-btn', { disabled: isDisabled })}>
          {outreachType.actionLabel(validSelectedTalent.length)}
        </div>
      </div>
      {note && (
        <div className='num-remaining-container'>
          <div className={cn('num-remaining', { warn: false })}>{note}</div>
        </div>
      )}
    </div>
  );
};

BulkTalentModalFooter.propTypes = {
  curMessage: PropTypes.string.isRequired,
  curRate: PropTypes.string.isRequired,
  validSelectedTalent: PropTypes.array.isRequired,
  outreachOptions: PropTypes.array.isRequired,
  outreachType: PropTypes.object.isRequired,
  setOutreachTypeEnum: PropTypes.func.isRequired
};

export default BulkTalentModalFooter;
